import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useGoalProgress } from './useGoalProgress'
import { GOAL_FIELDS } from '../health-cycle/goalFields'

const fmt = (v) => (v === null || v === undefined ? '–' : Math.round(Number(v) * 10) / 10)

// VH-231: replaces the old "AI Analysis" tab — a summary of the current cycle and a link into it.
export function HealthCycleTab() {
  const { t } = useTranslation()
  const { data, isLoading, isError } = useGoalProgress()

  if (isLoading) return <p className="text-sm text-gray-500">{t('common.loading')}</p>
  if (isError) return <p className="text-sm text-red-600">{t('untilNextTest.error')}</p>

  const cycle = data?.cycle
  if (!cycle) {
    return (
      <div className="card" data-testid="health-cycle-tab-empty">
        <div className="card-body space-y-3 text-sm">
          <h3 className="text-lg font-medium text-gray-900">{t('healthCycleTab.emptyTitle')}</h3>
          <p className="text-gray-600">{t('healthCycleTab.emptyText')}</p>
          <div className="flex flex-wrap gap-2">
            <Link to="/blood-tests" className="btn-primary">{t('healthCycleTab.startFromBloodTest')}</Link>
            <Link to="/health-cycle" className="btn-outline">{t('healthCycleTab.history')}</Link>
          </div>
        </div>
      </div>
    )
  }
  const goal = data.cycle_goal
  return (
    <div className="card" data-testid="health-cycle-tab">
      <div className="card-body space-y-4 text-sm">
        <div className="flex flex-wrap justify-between gap-2">
          <div>
            <h3 className="text-lg font-medium text-gray-900">{t('healthCycleTab.title')}</h3>
            <p className="text-gray-600">
              {t('healthCycleTab.bloodTest', { date: cycle.blood_test_date })} · {t(`healthCycleTab.status.${cycle.status}`, cycle.status)}
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Link to={`/health-cycle/cycles/${cycle.id}`} className="btn-primary">{t('healthCycleTab.open')}</Link>
            <Link to="/health-cycle" className="btn-outline">{t('healthCycleTab.history')}</Link>
          </div>
        </div>
        {cycle.verdict && <p className="text-gray-800" data-testid="cycle-verdict">{cycle.verdict}</p>}
        {goal && (
          <div>
            <p className="font-medium text-gray-900">{t('healthCycleTab.goal')}</p>
            <ul className="mt-1 grid grid-cols-2 md:grid-cols-4 gap-2">
              {GOAL_FIELDS.filter((f) => goal[f.key] != null).map((f) => (
                <li key={f.key} className="rounded bg-gray-50 px-2 py-1">
                  <span className="block text-xs text-gray-500">{t(`goalFields.${f.key}`)}</span>
                  <span className="font-medium text-gray-900">{fmt(goal[f.key])} {f.unit}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  )
}

export default HealthCycleTab
